import request from '@/utils/request'
//发送验证码
export function PhoneCode(data){
    return request({
       // url:'http://api.gcszwyc.com:10080/webapi/sendsms/sendPhoneSms?phone=18874795221',
       url:'/webapi/sendsms/sendPhoneSms',
        method: 'GET',
        params:{phone:data}
    })
}
//用户登录
export function UserLogin(obj){
    return request({
        url:'/webapi/passenger/login',
        method:'post',
        data:obj
    })
}
//用户是否已经登录
export function UserIslogin(data){
    return request({
        url:'/webapi/passenger/islogin',
        method:'post',
        data:data
    })
}
//解密token
export function decodeTokenFun(decode){
    return request({
        url:'/webapi/passenger/decryptToken',
        method:'GET',
        params:{decryptStr:decode}
    })
}

